// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';

import Modal from './Modal';
import api from '../../api';
import plural from '../../utilities/plural';

const UPLOAD_BATCH_SIZE = 10;

export default class BatchUpload extends Modal {

    state = {
        uploads: []
    }

    componentDidMount = () => {
        this.upload(this.props.data);
    }

    componentWillReceiveProps = (next) => {
        if (this.props.data !== next.data)
            this.upload(next);
    }

    getExtension = (filename) => filename.split(".").slice(-1).pop().toLowerCase();

    setProgress = (idx, progress) => this.setState(prev => {
        let uploads = prev.uploads.slice();
        uploads[idx].uploaded = progress;
        return ({ uploads });
    })

    upload = async (data) => {
        const target = data.target;
        const files = data.files;

        if (!files) {
            toast.error("Unable to batch upload files...");
            return this.props.modal();
        }

        await this.setState({ uploads: files.map(f => ({
            name: f.name,
            file: f,
            uploaded: 0
        })) });

        // Upload one by one and track
        for (let i=0; i<this.state.uploads.length; i+=UPLOAD_BATCH_SIZE) {
            await Promise.all(this.state.uploads.slice(i,i+UPLOAD_BATCH_SIZE).map(async (upload, idx) => {
                // let formData = new FormData();
                // if (target) formData.set('stackId', target);
                // formData.append('files', upload.file);
                // const res = await api.post('/document/upload', formData, false, {
                //     onUploadProgress: (e) => this.setProgress(idx, 0.7 * (e.loaded / e.total))
                // });

                // Step 1: Create document placeholder and get presigned upload URL
                const res = await api.post('/document/create', {
                    stackId: target,
                    names: [ upload.name ]
                });

                if (!res || !res.uploads || !res.uploads.length || !res.uploads[0].upload) return toast.error("Something went wrong when trying to upload: " + upload.name);
                
                this.setProgress(i+idx, 0.1);

                // Upload document using the presigned Url
                try {
                    await axios.put(res.uploads[0].upload.url, upload.file, {
                        onUploadProgress: (e) => this.setProgress(i+idx, 0.9 * (e.loaded / e.total)),
                        headers: { 'Content-Type': 'application/octet-stream' }
                    });
                    // await fetch(res.uploads[0].url, {
                    //     method: 'PUT',
                    //     body: upload.file,
                    //     headers: { 'Content-Type': 'application/octet-stream' }
                    // });
                }

                catch (error) {
                    return toast.error("Something went wrong while uploading: " + upload.name);
                }

                // Let Stax·ai know to start processing this document
                await api.post('/document/process', {
                    docIds: [ res.uploads[0]._id ]
                });

                if (res && res.uploads) {
                    if (target === this.props.stack._id)
                        await this.props.registerUpload(res.uploads);

                    await this.setState(prev => {
                        let uploads = prev.uploads.slice();
                        uploads[i+idx].uploaded = 1;
                        return ({ uploads });
                    });
                }

                return 0;
            }));
        }

        const nUploads = this.state.uploads.filter(u => u.uploaded === 1).length;

        if (nUploads === this.state.uploads.length)
            toast.success('Uploaded ' + nUploads + plural(' document', nUploads) + '! Stax bots will process them soon...');

        else if (nUploads === 0)
            toast.error('Oops, something went wrong! We couldn\'t upload your files.');

        else toast.error('Uploaded ' + nUploads + plural(' document', nUploads) + ', but the rest couldn\'t be uploaded.');
        
        await this.props.loadRootData(); // Reload
        
        setTimeout(this.props.modal, 1000);
        
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">

            <h1>Uploaded {this.state.uploads.filter(u => u.uploaded === 1).length} of {this.state.uploads.length} files...</h1>

            <div className="modal-batch-uploads">
                {this.state.uploads.map((u,idx) => <div
                    key={idx}
                    className="modal-batch-file"
                >
                    <div
                        className="modal-batch-filename"
                        style={{
                            backgroundImage: "url('https://static.stax.ai/images/format/" + this.getExtension(u.name) + ".png')"
                        }}
                        title={u.name}
                    >{u.name}</div>
                    <div className="modal-batch-status">
                        <div
                            className={"modal-batch-indicator" + (u.uploaded > 0 && u.uploaded < 1 ? " modal-batch-uploading" : "")}
                            style={{ width: (u.uploaded*100).toFixed(2) + "%" }}
                        />
                    </div>
                </div>)}
            </div>
            
        </div>);
    }

};